import { HeroBannerFeaturedCardList } from './HeroBannerFeaturedCardList';
import { JoinContainer } from './JoinContainer';

export const HeroBanner = () => {
    return (
        <div
            className="flex flex-col"
            data-testid="treasureHuntingContainer"
        >
            <div className="mx-auto my-0 flex h-full max-h-[238px] w-[calc(100%-40px)] max-w-[1200px] smMax:max-h-none smMax:flex-col">
                <JoinContainer />
                <HeroBannerFeaturedCardList />
            </div>
        </div>
    );
};
